import { darkBackgroundBlur } from '@repo/ui/components/utilities';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const MenuButton = styled.div<{ $buttonHeight?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5px;
  height: ${({ $buttonHeight }) => $buttonHeight || '34px'};
  width: 45px;
  border-radius: ${themeStyle.radiusMedium};
  border: none;
  background-color: ${themeStyle.transparent};
  transition: background 150ms ease-in;
  cursor: pointer;

  &:hover {
    background-color: ${themeStyle.varInkSuperLight};
  }

  &[data-state='open'] {
    background-color: ${themeStyle.varInkSuperLight};
  }

  & > div {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background-color: ${themeStyle.varInkMain};
  }
`;

export const MenuWrapper = styled.div`
  width: 180px;
  background-color: ${themeStyle.varBackgroundAlt};
  box-shadow: ${themeStyle.varShadowHeavy};
  padding: 12px;
  border-radius: ${themeStyle.radiusLarge};

  ${darkBackgroundBlur}

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
`;
